import { dataHeadphones } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHeadphones = /*#__PURE__*/createIcon(dataHeadphones)
export default IconHeadphones
